import React from 'react';
import CommonWelcomeAdd from '../../../components/Welcome/CommonWelcomeAdd';

const WelcomeInAdd = () => {
    return (
        <CommonWelcomeAdd
            pageName='Pazarlama > Karşılamalar > Antrepo Yükleme'
            isOut={false}
            isIn={true}
        />
    )
}

export default WelcomeInAdd;